import { GrowthBook, GrowthBookProvider as RealGrowthBookProvider, GrowthBookSSRData } from '@growthbook/growthbook-react'
import React, { useEffect, useRef } from 'react'
import { config } from 'utils/config'
import { useCurrentUser } from 'modules/auth/useCurrentUser'
import { getClientKey } from './utils/getClientKey'
import { getInitialAttributes } from './utils/getInitialAttributes'

const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: getClientKey(),
  enableDevMode: config.apiEnv === 'development',
  trackingCallback: (experiment, result) => {
    if (typeof window !== 'undefined') {
      window.analytics.track('Viewed Experiment', {
        experimentId: experiment.key,
        variationId: result.key
      })
    }
  }
})

interface Props {
  children: React.ReactNode
  ssrData: GrowthBookSSRData
  segmentTrackingId: string
}
export const GrowthBookProvider = ({ children, ssrData = { attributes: {}, features: {} }, segmentTrackingId }: Props) => {
  const { user } = useCurrentUser()
  const isInitialRender = useRef(true)

  if (isInitialRender.current) {
    growthbook.setFeatures(ssrData.features)
    growthbook.setAttributes(ssrData.attributes)
    isInitialRender.current = false
  }

  useEffect(() => {
    growthbook.loadFeatures({ autoRefresh: true })
  }, [])

  useEffect(() => {
    growthbook.setAttributes(getInitialAttributes({ user, segmentTrackingId }))
  }, [user, segmentTrackingId])

  return <RealGrowthBookProvider growthbook={growthbook}>{children}</RealGrowthBookProvider>
}
